var React = require('react');

function HomeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.8112 11.8034L13.9112 0.262836C13.8255 0.179517 13.7237 0.113416 13.6117 0.0683154C13.4996 0.0232147 13.3795 0 13.2582 0C13.1369 0 13.0168 0.0232147 12.9048 0.0683154C12.7928 0.113416 12.691 0.179517 12.6053 0.262836L0.705254 11.8034C0.358566 12.1398 0.162109 12.5969 0.162109 13.0735C0.162109 14.0633 0.991271 14.8679 2.01111 14.8679H3.26497V23.1028C3.26497 23.5991 3.6781 24 4.18947 24H11.4092V17.7194H14.645V24H22.327C22.8384 24 23.2515 23.5991 23.2515 23.1028V14.8679H24.5054C24.9965 14.8679 25.4674 14.6801 25.8141 14.3408C26.5335 13.6399 26.5335 12.5043 25.8112 11.8034Z","fill":"current"}));
}

HomeIcon.defaultProps = {"width":"27","height":"24","viewBox":"0 0 27 24","fill":"none"};

module.exports = HomeIcon;

HomeIcon.default = HomeIcon;
